import { db } from '../firebaseConfig';
import { doc, getDoc, setDoc, serverTimestamp } from 'firebase/firestore';

/**
 * Service Firestore pour la progression du parcours.
 *
 * Responsabilite simplifiee : CRUD sur parcoursProgression/{userId}.
 * La logique de calcul des statuts est dans parcoursNavigationEngine.js.
 * Le stockage local est dans parcoursProgressionStorage.js.
 */
class ParcoursProgressionService {

  /**
   * Recupere la progression parcours depuis Firestore.
   * @param {string} userId
   * @returns {Promise<Object|null>}
   */
  async getUserProgression(userId) {
    try {
      const ref = doc(db, 'parcoursProgression', userId);
      const snap = await getDoc(ref);
      if (!snap.exists()) return null;
      return snap.data();
    } catch (error) {
      console.error('[ParcoursService] Erreur lecture:', error);
      return null;
    }
  }

  /**
   * Met a jour la position de l'utilisateur dans le parcours.
   * @param {string} userId
   * @param {string} stepId - ID du step courant
   * @param {string|null} exerciseId - ID de l'exercice en cours
   */
  async updateLastVisited(userId, stepId, exerciseId) {
    if (!userId || !stepId) return; // Eviter d'envoyer undefined a Firestore
    try {
      const ref = doc(db, 'parcoursProgression', userId);
      await setDoc(ref, {
        lastStepVisited: stepId,
        lastExerciseId: exerciseId || null,
        lastSessionDate: serverTimestamp()
      }, { merge: true });
    } catch (error) {
      console.error('[ParcoursService] Erreur mise a jour:', error);
    }
  }

  /**
   * Initialise la progression parcours pour un nouvel utilisateur.
   * @param {string} userId
   */
  async initializeParcours(userId) {
    try {
      const ref = doc(db, 'parcoursProgression', userId);
      await setDoc(ref, {
        userId,
        isActive: true,
        currentChapitre: 1,
        lastStepVisited: 'p1-1',
        lastExerciseId: null,
        startedAt: serverTimestamp(),
        lastSessionDate: serverTimestamp()
      });
    } catch (error) {
      console.error('[ParcoursService] Erreur initialisation:', error);
    }
  }
}

export default new ParcoursProgressionService();
